import React, { memo } from 'react';
import PercentTendencyFloat from '@gp/components/PercentTendencyFloat';
import { getFormatNumPlus, getFormatPercentPlus, isValidNumber, getNumberOfDotUnit } from '@gp/utils/common';
import { NumberTdCellType } from '../../index.d';
import './index.scss';

interface CommonValueTdPropsType {
  tdAlign: "left" | "right" | (string & {}),
  options: NumberTdCellType[],
  data: any,
}

const DEFAULT_PROPS: CommonValueTdPropsType = {
  tdAlign: 'left',
  options: [],
  data: null,
};

function CommonValueTd(props: CommonValueTdPropsType) {

  const {
    tdAlign,
    options,
    data,
  } = props;

  return (
    <hgroup
      className="gp-common-value-td"
      style={{
        justifyContent: tdAlign === 'right' ? 'flex-end' : 'flex-start',
      }}
    >
      {Array.isArray(options) && options?.map((t, i) => {
        const {
          type,
          value,
          isTitle = false,
          isFormat = false,
          isKeepInt = false,
          className,
          style = {},
          isTendencyLabel = false,
          label,
          isEmptyHidle = false,
          isRenderDoubleTendency = false,
          doubleTendencyValue,
          doubleLabel,
        } = t || {};
        const realValue = data?.[value || ''], realDoubleTendencyValue = data?.[doubleTendencyValue || ''];
        const isValidV = isValidNumber(realValue),
              isValidDoubleTendencyV = isValidNumber(realDoubleTendencyValue);
        switch (type) {
          case 'value':
            const realV = isFormat
              ? getFormatNumPlus(realValue)
              : isKeepInt
                ? (isValidV ? getNumberOfDotUnit(Math.round(realValue)) : '')
                : realValue;
            return (!isValidV && isEmptyHidle) ? null : (
              <div
                key={i}
                className={`gp-common-value-dbg-table-metrics-valuealue ${className}`}
                style={style}
                title={isTitle ? realV : undefined}
              >
                {realV || '-'}
              </div>
            );

          case 'tendency':
            return (!isValidV && !isValidDoubleTendencyV && isEmptyHidle) ? null : (
              <div key={i} className="dbg-common-value-td-tendency">
                <div
                  className={`dbg-common-value-td-tendency-item ${className}`}
                  style={{
                    ...style,
                    justifyContent: tdAlign === 'right' ? 'flex-end' : 'flex-start',
                  }}
                >
                  <span className="dbg-common-value-td-tendency-item-percent">
                    <PercentTendencyFloat value={realValue} />
                  </span>
                  {isTendencyLabel && (<span className="dbg-common-value-td-tendency-item-label">{label}</span>)}
                </div>
                {isRenderDoubleTendency && (
                  <div
                    className={`dbg-common-value-td-tendency-item ${className}`}
                    style={{
                      ...style,
                      justifyContent: tdAlign === 'right' ? 'flex-end' : 'flex-start',
                    }}
                  >
                    <span className="dbg-common-value-td-tendency-item-percent">
                      <PercentTendencyFloat value={realDoubleTendencyValue} />
                    </span>
                    {isTendencyLabel && (<span className="dbg-common-value-td-tendency-item-label">{doubleLabel}</span>)}
                  </div>
                )}
              </div>
            );

          case 'percent':
            const realP = isFormat ? getFormatPercentPlus(realValue) : realValue;
            return (!isValidV && isEmptyHidle) ? null : (
              <section
                key={i}
                className={`gp-common-value-td-percent ${className}`}
                style={style}
                title={isTitle ? realV : undefined}
              >
                {realP || '-'}
              </section>
            );
        
          default:
            return null;
        }
      })}
    </hgroup>
  );
}

CommonValueTd.defaultProps = DEFAULT_PROPS;

export default memo(CommonValueTd);
